var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C9.38071 10.5 10.5 9.38073 10.5 8.00002C10.5 6.6193 9.38071 5.50002 8 5.50002C6.61929 5.50002 5.5 6.6193 5.5 8.00002C5.5 9.38073 6.61929 10.5 8 10.5Z",
    stroke: "#737373",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.25002H5.25C3.59315 2.25002 2.25 3.59316 2.25 5.25002V10.75C2.25 12.4069 3.59315 13.75 5.25 13.75H10.75C12.4069 13.75 13.75 12.4069 13.75 10.75V5.25002C13.75 3.59316 12.4069 2.25002 10.75 2.25002Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.50002C11.6642 5.50002 12 5.16423 12 4.75002C12 4.3358 11.6642 4.00002 11.25 4.00002C10.8358 4.00002 10.5 4.3358 10.5 4.75002C10.5 5.16423 10.8358 5.50002 11.25 5.50002Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.11a0b0b85045c60fe08fd90ed413a5fa.svg";
export { ForwardRef as ReactComponent };